var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container mb-5" },
    [
      _c("div", { staticClass: "k-tabs" }, [
        _c("ul", { staticClass: "k-tabs__list" }, [
          _c(
            "li",
            {
              staticClass: "k-tabs__item",
              class: [
                { "k-tabs__item--active": _vm.activeTab === "myDocuments" }
              ],
              on: {
                click: function($event) {
                  return _vm.tabChanged("myDocuments")
                }
              }
            },
            [
              _c(
                "a",
                {
                  staticClass: "k-tabs__link",
                  attrs: { href: "javascript:;" }
                },
                [
                  _vm._v(
                    "Moje dokumenty (" + _vm._s(_vm.myDocumentsCount) + ")"
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "li",
            {
              staticClass: "k-tabs__item",
              class: [
                {
                  "k-tabs__item--active": _vm.activeTab === "watchingDocuments"
                }
              ],
              on: {
                click: function($event) {
                  return _vm.tabChanged("watchingDocuments")
                }
              }
            },
            [
              _c(
                "a",
                {
                  staticClass: "k-tabs__link ",
                  attrs: { href: "javascript:;" }
                },
                [
                  _vm._v(
                    "Sledované dokumenty (" +
                      _vm._s(_vm.watchingDocumentsCount) +
                      ")"
                  )
                ]
              )
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "k-tabs__actions" }, [
          _c(
            "a",
            {
              staticClass: "k-tabs__actions-link",
              attrs: { href: _vm.DocumentsListLink }
            },
            [
              _vm._v("\n                Dokumenty\n                "),
              _c(
                "svg",
                {
                  staticClass:
                    "k-tabs__actions-icon k-tabs__actions-icon--after",
                  attrs: { role: "img", width: "15", height: "15" }
                },
                [
                  _c("use", {
                    attrs: {
                      fill: "currentColor",
                      "xlink:href": "/images/spritesheet.svg#arrow-right"
                    }
                  })
                ]
              )
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "transition-group",
        {
          staticClass: "k-table",
          attrs: { name: "list-complete", tag: "div" }
        },
        [
          _vm._l(_vm.documents.data, function(document) {
            return _c(
              "div",
              { key: document.id, staticClass: "k-table__row" },
              [
                _c("div", { staticClass: "k-table__cell" }, [
                  _c("div", { staticClass: "k-file-meta k-mr-20" }, [
                    _c(
                      "svg",
                      {
                        staticClass: "k-file-meta__icon",
                        attrs: { role: "img", width: "24", height: "25" }
                      },
                      [
                        _c("use", {
                          attrs: {
                            fill: "currentColor",
                            "xlink:href": "/images/spritesheet.svg#file-pdf"
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "k-file-meta__text" }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(document.size_formatted) +
                          "\n                    "
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "mr-auto" }, [
                    _c(
                      "a",
                      {
                        staticClass: "mb-1 d-block",
                        attrs: { href: document.detail_url }
                      },
                      [
                        _c("strong", { staticClass: "k-strong" }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(document.title) +
                              "\n                        "
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "k-table__cell-meta ml-0" },
                      _vm._l(document.categories, function(url, title) {
                        return _c(
                          "a",
                          { staticClass: "k-link mr-2", attrs: { href: url } },
                          [_vm._v(_vm._s(title))]
                        )
                      }),
                      0
                    )
                  ]),
                  _vm._v(" "),
                  document.status && document.status !== null
                    ? _c(
                        "span",
                        {
                          staticClass: "k-table__cell-meta k-label",
                          class: document.status.class
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(document.status.text) +
                              "\n                "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("span", { staticClass: "k-table__cell-meta" }, [
                    _vm._v(_vm._s(document.created_at))
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "k-table__cell k-table__cell--action" },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "k-action k-action--control",
                        attrs: { href: document.detail_url }
                      },
                      [
                        _c(
                          "svg",
                          {
                            staticClass: "k-action__icon",
                            attrs: { role: "img", width: "15", height: "15" }
                          },
                          [
                            _c("use", {
                              attrs: {
                                fill: "currentColor",
                                "xlink:href": "/images/spritesheet.svg#eye"
                              }
                            })
                          ]
                        ),
                        _vm._v(
                          "\n                    Zobrazit\n                "
                        )
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "k-table__cell k-table__cell--action" },
                  [
                    document.zip_url !== null
                      ? [
                          _c(
                            "a",
                            {
                              staticClass: "k-action k-action--control",
                              attrs: { href: document.zip_url }
                            },
                            [
                              _c(
                                "svg",
                                {
                                  staticClass: "k-action__icon",
                                  attrs: {
                                    role: "img",
                                    width: "15",
                                    height: "15"
                                  }
                                },
                                [
                                  _c("use", {
                                    attrs: {
                                      fill: "currentColor",
                                      "xlink:href":
                                        "/images/spritesheet.svg#download"
                                    }
                                  })
                                ]
                              ),
                              _vm._v(
                                "\n                        Stáhnout\n                    "
                              )
                            ]
                          )
                        ]
                      : [_c("strong", [_vm._v("Zpracovávám")])]
                  ],
                  2
                )
              ]
            )
          }),
          _vm._v(" "),
          _vm.documents.data && _vm.documents.data.length === 0
            ? _c("div", { key: "0", staticClass: "k-table__cell p-3" }, [
                _vm._v(
                  "\n            Nebyly nalezeny žádné dokumenty.\n        "
                )
              ])
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c("pagination", {
        staticClass: "mt-5",
        attrs: { data: _vm.documents, limit: 2 },
        on: { "pagination-change-page": _vm.getData }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }